
const state = {
    statusbatchRead: 'on', //连读状态
    statuspointread: 'on', //指读状态
    statusSpeakOnOff: 'on', //朗读模块
    speakerStatus: false,
    automateSpeakStatus: false,
    keybordSpeakStatus: false,
    speedVal: 0, //语速
    // sound 对象相关
    mp3Object: null, //mp3对象
    autoSpeakObj: null, //自动朗读对象
    voicePromptObject: null, //播放语音提示对象
    index: 0, //页面信息索引 用于自动朗读
    source: [], //预存页面信息 用于自动朗读
    thisdomAuto: null, //自动朗读对象
    thisdomAutoParent: null, //自动朗读对象父级
    thisdomAutoParent_type: 'css', //类型
    thisdomAutoParent_back: null, //自动对象父级对象css
    thisdom: null, //指读/键盘朗读对象
    thisdomAuto_type: 'css', //
    thisdomAuto_back: null, //自动朗读对象CSS
    thisdomAuto_font: null, //自动朗读文字对象CSS
    thisdom_type: 'css', //
    thisdom_back: null, //指读、键盘朗读对象CSS
    thisdom_font: null, //指读、键盘朗读文字对象CSS
    iframe_change: 0, //是否有修改
    thisdomPoint: null,
    thisdomKB: null,
}

const mutations = {
    setMp3Object (state, mp3Object) {
        state.mp3Object = mp3Object
    },
    setSpeakerStatus (state, speakerStatus) {
        state.speakerStatus = speakerStatus
    },
    setAutomateSpeakStatus (state, automateSpeakStatus) {
        state.automateSpeakStatus = automateSpeakStatus
    },
    setKeybordSpeakStatus (state, keybordSpeakStatus) {
        state.keybordSpeakStatus = keybordSpeakStatus
    },
    setThisDom (state, thisdom) {
        state.thisdom = thisdom
    },
    setStatuspointread (state, statuspointread) {
        state.statuspointread = statuspointread
    },
    setStatusbatchRead (state, statusbatchRead) {
        state.statusbatchRead = statusbatchRead
    },
    setIframeChange (state, iframe_change) {
        state.iframe_change = iframe_change
    },
    setThisdomType (state, thisdom_type) {
        state.thisdom_type = thisdom_type
    },
    setThisdom (state, thisdom) {
        state.thisdom = thisdom
    },
    setThisdomFont (state, thisdom_font) {
        state.thisdom_font = thisdom_font
    },
    setThisdomBack (state, thisdom_back) {
        state.thisdom_back = thisdom_back
    },
    setThisdomPoint (state, thisdomPoint) {
        state.thisdomPoint = thisdomPoint
    },
    setThisdomKB (state, thisdomKB) {
        state.thisdomKB = thisdomKB
    },
    setSource (state, source) {
        state.source = source
    },
    setIndex (state, index) {
        state.index = index
    },
    setThisdomAuto (state, thisdomAuto) {
        state.thisdomAuto = thisdomAuto
    },
    setThisdomAutoBack (state, thisdomAuto_back) {
        state.thisdomAuto_back = thisdomAuto_back
    },
    setThisdomAutoFont (state, thisdomAuto_font) {
        state.thisdomAuto_font = thisdomAuto_font
    },
    setThisdomAutoParentBack (state, thisdomAutoParent_back) {
        state.thisdomAutoParent_back = thisdomAutoParent_back
    },
    setThisdomAutoParent (state, thisdomAutoParent) {
        state.thisdomAutoParent = thisdomAutoParent
    },
    setThisdomAutoType (state, thisdomAuto_type) {
        state.thisdomAuto_type = thisdomAuto_type
    },
    setThisdomAutoBack (state, thisdomAuto_back) {
        state.thisdomAuto_back = thisdomAuto_back
    },
    setThisdomAutoFont (state, thisdomAuto_font) {
        state.thisdomAuto_font = thisdomAuto_font
    },
    setAutoSpeakObj (state, autoSpeakObj) {
        state.autoSpeakObj = autoSpeakObj
    },
    setVoicePromptObject (state, voicePromptObject) {
        state.voicePromptObject = voicePromptObject
    },
    setSpeedVal (state, speedVal) {
        state.speedVal = speedVal
    },
    setStatusSpeakOnOff (state, statusSpeakOnOff) {
        state.statusSpeakOnOff = statusSpeakOnOff
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/speak.js